import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IView } from "../../interfaces/IView";
import _ from "lodash";
import { getProductColors, getViewData } from "../../api/editor.api";
import { fabric } from "fabric";
import { APP_CONSTANTS } from "../../../constants/AppConstants";
import { getPrintMethodDetails } from "../../../api/product.api";
import {
  applyEffectToImage,
  getOverlayImageAsAString,
} from "../../../utils/utils";
// import { applyEffectToImage } from "../../../utils/utils";

export interface IViewsSlice {}

const initialState: any = {
  exportedProp: APP_CONSTANTS.propToExport,
  original_view_data: [],
  product_data: [],
  loading: false,
  canvasData: {},
  selectedViewId: null,
  selected_product_color: null,
  jsonData: {},
  selectedObject: null,
  selectedEffect: null,
  historyLength: 0,
  designImageURL: null,
  designName: null,
};

export const createProductViewCanvas = (viewData: IView[]) => {
  return new Promise((resolve, reject) => {
    let productCanvas = document.createElement("canvas");
    let finalURLs = [];
    let counter: any = 0;
    let maxLength = viewData.length - 1;
    let viewList = viewData;

    const design_data: any = {};

    function loadImageAsBase64(imageUrl: string): Promise<string> {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";

        img.onload = function () {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          if (!ctx) {
            reject("Could not get 2D context");
            return;
          }
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0, img.width, img.height);

          const base64Data = canvas.toDataURL("image/png");
          resolve(base64Data);
        };

        img.onerror = function (error) {
          reject(error);
        };

        img.src = imageUrl;
      });
    }

    function convertImagesToBase64(svgString: string): Promise<string> {
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(svgString, "image/svg+xml");
      const images = svgDoc.getElementsByTagName("image");
      const gridLine = svgDoc.getElementById("gridLine");
      if (gridLine && gridLine.parentNode) {
        gridLine.parentNode.removeChild(gridLine);
      }

      const promises: Promise<void>[] = [];

      for (let i = 0; i < images.length; i++) {
        const image = images[i];
        const imageUrl: any =
          image.getAttributeNS("http://www.w3.org/1999/xlink", "href") ||
          image.getAttribute("href");

        if (imageUrl && imageUrl.startsWith("data:image/")) {
          continue;
        }

        const promise = loadImageAsBase64(imageUrl).then((base64Data) => {
          if (imageUrl) {
            image.setAttributeNS(
              "http://www.w3.org/1999/xlink",
              "href",
              base64Data
            );
          } else {
            image.setAttribute("href", base64Data);
          }
        });

        promises.push(promise);
      }

      return Promise.all(promises).then(() => {
        return new XMLSerializer().serializeToString(svgDoc);
      });
    }

    function generateImage(counter: any) {
      const viewData = viewList[counter];
      productCanvas.width = viewData.productImageWidth;
      productCanvas.height = viewData.productImageHeight;
      var ctx: any = productCanvas.getContext("2d");
      var img = document.getElementById("product-image-" + viewData.id);
      // img.crossOrigin = "Anonymous";
      ctx.drawImage(img, 0, 0, productCanvas.width, productCanvas.height);
      const win: any = window;
      const canvas: any = win["design_canvas"][viewData.id];
      var canvasImage = canvas.toDataURL();

      let designImage = document.createElement("img");
      designImage.onload = async function () {
        ctx.drawImage(
          designImage,
          viewData.left,
          viewData.top,
          viewData.width,
          viewData.height
        );

        let img2 = new Image();
        img2.src = productCanvas.toDataURL();

        let ob: any = {};
        ob[viewData.id] = productCanvas.toDataURL();
        finalURLs.push(ob);
        const svg = await convertImagesToBase64(canvas.toSVG());
        design_data[viewData.id] = {
          image_url: productCanvas.toDataURL(),
          svg: svg,
          design_image: canvas.toDataURL(),
          json: canvas.toJSON(APP_CONSTANTS.propToExport),
          name: viewData.name,
        };

        // /**
        //  * Temp Code
        //  */
        // var link = document.createElement("a");
        // link.download = viewData.id;
        // link.href = ob[viewData.id];
        // link.click();
        /**
         * -------------------------Code end
         */
        // $('body').append(img2);
        if (maxLength == counter) {
          resolve(design_data);
        } else {
          counter++;
          generateImage(counter);
        }
        // callBack(productCanvas.toDataURL(ob))
      };

      designImage.src = canvasImage;
    }
    generateImage(counter);
  });
};
export const fetchViewData = createAsyncThunk(
  "views/fetchViewData",
  async (payload: any, { dispatch }) => {
    const viewDataArray = await getViewData(
      payload.id,
      payload.podId ? payload.podId : 0
    );
    const firstViewData: any = viewDataArray[0];
    const printMethod = firstViewData.print_method;

    const effectData = printMethod
      ? await getPrintMethodDetails(printMethod.split(",")[0])
      : null;

    return {
      viewData: viewDataArray,
      effectData,
      printMethod,
      designName: firstViewData.designName,
    };
  }
);

export const getDesign = createAsyncThunk(
  "views/getDesignData",
  async (payload: any, { dispatch }) => {
    const [viewData, productColorData] = await Promise.all([
      getViewData(1),
      getProductColors(),
    ]);

    return { viewData, productColorData };
  }
);

export const fetchProductColors = createAsyncThunk(
  "views/fetchProductColors",
  async (payload: any, { dispatch }) =>
    getProductColors().then((res) => {
      return res;
    })
);

export const generateDesignData = createAsyncThunk(
  "views/generateDesignData",
  async (payload: any, { dispatch, getState }) => {
    const state: any = getState();

    return createProductViewCanvas(state.canvases.original_view_data).then(
      (data: any) => {
        /**
         * "print_area_px_w": 255,
        "print_area_px_h": 300,
        "print_area_mm_w": 68,
        "print_area_mm_h": 80
         */
        Object.keys(data).map((key: any) => {
          var existingItem = state.canvases.original_view_data.find(
            (item: any) => item.id === parseInt(key)
          );
          var svgString = data[key].svg;
          var tempDiv = document.createElement("div");
          tempDiv.innerHTML = svgString;

          // Get the SVG element from the temporary div
          var svgElement: any = tempDiv.querySelector("svg");

          // Set the new width and height values based on your calculations
          var newWidth =
            existingItem.printUnit === "mm"
              ? existingItem.printWidth * 2.834645669291339
              : existingItem.printWidth * 96;
          // ? existingItem.printWidth * 3.7795275590551
          // : existingItem.printWidth * 96;
          var newHeight =
            existingItem.printUnit === "mm"
              ? existingItem.printHeight * 2.834645669291339
              : existingItem.printHeight * 96;
          // ? existingItem.printHeight * 3.7795275590551
          // : existingItem.printHeight * 96;

          // Update the width and height attributes in the SVG element
          svgElement.setAttribute("width", newWidth);
          svgElement.setAttribute("height", newHeight);
          data[key].svg = svgElement.outerHTML;

          data[key].print_area_px_w = existingItem.width;

          data[key].print_area_px_h = existingItem.height;

          data[key].print_area_mm_w = existingItem.printWidth;
          data[key].print_area_mm_h = existingItem.printHeight;
          data[key].print_unit = existingItem.printUnit;
        });

        return data;
      }
    );
  }
);

const viewSlice = createSlice({
  name: "canvases",
  initialState,
  reducers: {
    updateDesignName: (state, action: PayloadAction<any>) => {
      state.designName = action.payload;
    },
    setCanvasJson: (state, action: PayloadAction<any>) => {
      state.canvasData[action.payload.id].customer_design =
        action.payload.design;
    },
    updateCanvasData: (state, action: PayloadAction<any>) => {
      const win: any = window;
      const canvas: any = win["design_canvas"][state.selectedViewId];
      state.jsonData[state.selectedViewId] = canvas.toJSON(state.exportedProp);
    },
    setSelectedView: (state, action: PayloadAction<any>) => {
      state.selectedViewId = action.payload;
    },
    setSelectObject: (state, action: PayloadAction<any>) => {
      state.selectedObject = action.payload;
    },
    resetObjectToInitialState: (state, action: PayloadAction<any>) => {
      const win: any = window;
      const canvas: any = win["design_canvas"][state.selectedViewId];

      const object = canvas.getActiveObject();
      if (object && object.myclone) {
        // Remove the current object from the canvas
        // canvas.remove(object);

        // Get the original left and top values from the clone
        const originalLeft = object.clone.left;
        const originalTop = object.clone.top;

        // Add the clone to the canvas
        // canvas.add(object.clone);
        if (object.myclone.filters && object.myclone.filters.length > 0) {
          object.myclone.filters = [];
        }
        // Set the object's position to the original left and top values
        object.set(object.myclone);
        if (object.type === "image") {
          object.applyFilters();
        }

        canvas.renderAll(); // Render the canvas to reflect the changes
        win.save();
      }
    },
    addText: (state, action: PayloadAction<any>) => {
      const selectedViewId = state.selectedViewId;
      const defaultTextOptions: any = {
        fontSize: 40,
        left: 190,
        top: 200,
        fill: "#000000",
        origin: "center",
        originX: "center",
        originY: "center",
        centeredRotation: true,

        id: _.uniqueId("_kodiak_id_"),
      };
      if (
        state.selectedEffect.image_overlay_image &&
        state.selectedEffect.overlay_pattern_to_text
      ) {
        const patternImage = state.selectedEffect.image_overlay_image;
        defaultTextOptions.pattern = null;
        var rect: any = new fabric.Text(
          action.payload ? action.payload : "Add Text Here",
          defaultTextOptions
        );

        const win: any = window;

        win["design_canvas"][selectedViewId].add(rect);
        const objectClone: any = rect.toJSON();
        rect["myclone"] = objectClone;
        setTimeout(() => {
          win["design_canvas"][selectedViewId].setActiveObject(rect);
          fabric.util.loadImage(
            patternImage,
            function (img) {
              rect.set(
                "fill",
                new fabric.Pattern({
                  source: img,
                  repeat: "repeat",
                })
              );

              win["design_canvas"][selectedViewId].renderAll();
              win.save();
            },
            null,
            "anonymous"
          );
        });
      } else {
        defaultTextOptions.pattern = null;
        var rect: any = new fabric.Text(
          action.payload ? action.payload : "Add Text Here",
          defaultTextOptions
        );

        const win: any = window;

        win["design_canvas"][selectedViewId].add(rect);
        const objectClone: any = rect.toJSON();
        rect["myclone"] = objectClone;
        setTimeout(() => {
          win["design_canvas"][selectedViewId].setActiveObject(rect);
        });
      }
    },
    addImage: (state, action: PayloadAction<any>) => {
      let originalImageUrl = action.payload.img;
      const selectedViewId = state.selectedViewId;
      const exportedProp = JSON.parse(JSON.stringify(state.exportedProp));
      const payload = action.payload;

      applyEffectToImage({
        selectedObjectImage: action.payload.img,
        selectedEffect: state.selectedEffect,
        fabric,
      }).then((imgUrl) => {
        const img = new Image();
        img.src = imgUrl;
        img.crossOrigin = "anonymous";

        const win: any = window;

        let cW = win["design_canvas"][selectedViewId].width;
        let cH = win["design_canvas"][selectedViewId].height;
        let sfW = cW / (payload.width + 30);
        let sfH = cH / (payload.height + 30);
        let sf = 1;
        if (sfW < sfH) {
          sf = sfW;
        } else {
          sf = sfH;
        }
        if (sf > 1) {
          sf = 1;
        }

        let imageW = sf * payload.width;
        let imageH = sf * payload.height;

        const payloadWidth = payload.width;
        const payloadHeight = payload.height;

        let left = (cW - imageW) / 2;
        let top = (cH - imageH) / 2;
        img.onload = () => {
          var imgInstance: any = new fabric.Image(img, {
            left: left + imageW / 2,
            top: top + imageH / 2,
            originalImg: originalImageUrl,
            angle: 0,
            originX: "center",
            originY: "center",
            width: payloadWidth,
            height: payloadHeight,
            centeredRotation: true,
            scaleX: sf,
            scaleY: sf,
            hasControl: false,
            crossOrigin: "anonymous",
            id: _.uniqueId("_kodiak_id_"),
          } as any);

          win["design_canvas"][selectedViewId].add(imgInstance);
          const objectClone: any = imgInstance.toJSON(exportedProp);
          imgInstance["myclone"] = objectClone;
          setTimeout(() => {
            win["design_canvas"][selectedViewId].setActiveObject(imgInstance);
            win["design_canvas"][selectedViewId].renderAll();
            win.save();
          });
          img.onload = null;
        };
      });
    },
    updateTextProp: (state, action: PayloadAction<any>) => {
      const win: any = window;
      const canvas: any = win["design_canvas"][state.selectedViewId];
      const prop = action.payload.prop;
      const value = action.payload.value;
      let object = canvas.getActiveObject();
      if (!object) return;

      if (prop === "objectAlignment") {
        if (value === "horizontal") object.centerH();
        else if (value === "vertical") object.centerV();
        else object.center();
      } else if (prop === "bringForward") {
        object.bringForward();
      } else if (prop === "sendBackwards") {
        object.sendBackwards();
      } else {
        object.set(prop, value);
      }
      state.selectedObject = JSON.parse(JSON.stringify(object));
      canvas.renderAll();
    },

    updateImageProp: (state, action: PayloadAction<any>) => {
      const win: any = window;
      const canvas: any = win["design_canvas"][state.selectedViewId];
      const prop = action.payload.prop;
      const value = action.payload.value;
      const isForced = false;
      let object = canvas.getActiveObject();

      if (prop !== "invert_color" && prop !== "background_threshold") {
        if (!object) return;
        if (prop === "objectAlignment") {
          if (value === "horizontal") object.centerH();
          else if (value === "vertical") object.centerV();
          else object.center();
        } else if (prop === "flipX" || prop === "flipY") {
          if (isForced) object[prop] = value;
          else
            object[prop] =
              object[prop] !== null &&
              object[prop] !== "" &&
              typeof object[prop] != "undefined"
                ? !object[prop]
                : true;
        } else if (prop === "bringForward") {
          object.bringForward();
        } else if (prop === "sendBackwards") {
          object.sendBackwards();
        } else if (prop === "filters") {
          if (value.type === "tint") {
            var filter = new fabric.Image.filters.BlendColor({
              color: value.color,
              mode: "tint",
            });

            object.filters[0] = filter;
            object.applyFilters();
          }
        } else if (prop === "removeFilter") {
          if (value.type === "tint") {
            object.filters[0] = false;
            object.applyFilters();
          }
        } else {
          object[prop] = value;
        }
        // state.selectedObject = JSON.parse(JSON.stringify(object));
        canvas.renderAll();
      } else {
        if (!object) return;
        const fabric = window.fabric;
        
        if (prop === "background_threshold") {
          // Store the threshold value on the object
          object.background_threshold = value;
          
          // If we already have the original image, process it with the current threshold
          if (object.originalImg) {
            applyEffectToImage({
              selectedObjectImage: object.originalImg,
              selectedEffect: {
                ...state.selectedEffect,
                image_threshold_value: value,
                image_effect: "black and transparent" // Set the effect to use thresholding
              },
              fabric,
            }).then((imgUrl) => {
              fabric.Image.fromURL(imgUrl, function (img) {
                // Update the image but preserve all properties and the original image
                object.setElement(img.getElement());
                object.set({
                  src: imgUrl,
                  background_threshold: value,
                  is_remove_background: true,
                  // Don't update originalImg - we need to keep the untouched original
                });
                canvas.renderAll();
                win.save();
              });
            });
          }
        } else if (prop === "invert_color") {
          applyEffectToImage({
            selectedObjectImage: object.originalImg
              ? object.originalImg
              : object.src,
            selectedEffect: {
              ...state.selectedEffect,
              image_is_invert_color:
                prop === "invert_color"
                  ? value
                  : state.selectedEffect.image_is_invert_color,
            },
            fabric,
          }).then((imgUrl) => {
            fabric.Image.fromURL(imgUrl, function (img) {
              object.setElement(img.getElement());
              object.set({
                invert_color: value,
                src: imgUrl,
                //originalImg: imgUrl,
                ...action.payload.extraProps,
              });
              canvas.renderAll();
              win.save();
            });
          });
        }
      }
    },
    updateImage: (state, action: PayloadAction<any>) => {
      const win: any = window;
      const canvas = win.design_canvas[state.selectedViewId]; // Assuming design_canvas is a global object

      // Find the image you want to update (assuming you have a reference to it)
      const imgInstance = canvas.getActiveObject();

      if (imgInstance && imgInstance.type === "image") {
        fabric.Image.fromURL(
          action.payload.img,
          function (newImg) {
            imgInstance.setElement(newImg.getElement());

            // Update other properties
            imgInstance.set({
              originalImg: action.payload.originalImg,
              ...action.payload.extraProps,
            });
            canvas.renderAll();
            win.save();
          },
          { crossOrigin: "anonymous" }
        );

        // const imgElement = imgInstance.getElement();

        // // Change the image source
        // //imgElement.src = action.payload.img;
        // imgInstance.originalImg = action.payload.originalImg;
        // imgInstance.set({ originalImg: action.payload.originalImg });
        // imgInstance.set({ src: action.payload.img });
        // imgInstance.set({ ...action.payload.extraProps });
        // Call renderAll to update the canvas
        canvas.renderAll();
        win.save();
      }
    },

    deSelectObject: (state, action: PayloadAction<any>) => {
      const win: any = window;
      const editors: any = win["design_canvas"][state.selectedViewId];
      editors.discardActiveObject(); // Deselect the currently active object, if any
      editors.renderAll(); // Render the canvas to reflect the changes]
    },
    startOver: (state, action: PayloadAction<any>) => {
      const win: any = window;

      for (const key in state.original_view_data) {
        const view = state.original_view_data[key];
        const editor: any = win["design_canvas"][view.id];
        editor.clear();
      }
    },
    updateColorImage: (state, action: PayloadAction<any>) => {
      const selectedColorData = action.payload;
      const newViewData = [];
      for (const key in state.original_view_data) {
        const view = state.original_view_data[key];
        view.img = selectedColorData.src;
        newViewData.push(view);
      }
      state.original_view_data = JSON.parse(JSON.stringify(newViewData));
    },

    generateDesignToSave: (state, action: PayloadAction<any>) => {
      const win: any = window;
      const editors: any = win["design_canvas"][state.selectedViewId];
      for (const key in editors) {
        const editor = editors[key];
        editor.clear();
      }
    },

    undo: (state) => {
      let win: any = window;
      win.replay(win.undo, win.redo, "#redo", this);
    },

    redo: (state) => {
      let win: any = window;
      win.replay(win.redo, win.undo, "#undo", this);
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchViewData.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchViewData.fulfilled, (state, action) => {
      state.original_view_data = action.payload.viewData;
      // state.product_data = action.payload.productColorData;
      state.product_data = [];
      const canvasData: any = {};
      for (let index = 0; index < action.payload.viewData.length; index++) {
        const view = action.payload.viewData[index];
        canvasData[view.id] = view;
      }
      state.canvasData = canvasData;
      state.selectedViewId = state.original_view_data[0].id;
      state.selectedEffect = action.payload.effectData;
      state.selectedPrintMethod = action.payload.printMethod;
      state.loading = false;
      state.designName = action.payload.designName;
    });
    //generateDesignData
    builder.addCase(generateDesignData.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(generateDesignData.fulfilled, (state, action) => {
      const win: any = window;

      state.designImageURL = action.payload
        ? action.payload[state.selectedViewId].image_url
        : null;
      state.loading = false;
    });
  },
});
export const {
  setCanvasJson,
  setSelectedView,
  addText,
  addImage,
  startOver,
  updateTextProp,
  updateImageProp,
  updateImage,
  updateCanvasData,
  setSelectObject,
  deSelectObject,
  resetObjectToInitialState,
  updateColorImage,
  undo,
  redo,
  updateDesignName,
} = viewSlice.actions;
export default viewSlice.reducer;
